module.exports = __webpack_public_path__ + "static/kerry_1_square-1a62864604d3a5cd57d043bf74ce0298.jpg";